export class PreferenceSelection {
  key: string;
  selectedValue: string;

  constructor(data, updates) {
    let selection = (data || {});
      this.key = this._useDefault((!!selection.key ? selection.key : ''), null);
      this.selectedValue = this._useDefault(((!!updates && !!updates.key && !!selection.key && !!updates.value) ? ((updates.key === selection.key) ? updates.value : (!!selection.selectedValue ? selection.selectedValue : null)) : null), null);

  }

  _useDefault(input, defaultVal) {
    return input ? input : (input === '' || input === false || input === 0) ? input : defaultVal;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/stay-preferences/preference-selection.model.ts